import ContentLoader from '@stimulus-components/content-loader'

class LoadTransactionsController extends ContentLoader {
  load () {
    super.load()

    const intervalId = setInterval(() => {
      const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]')
      if (tooltips.length > 0) clearInterval(intervalId)

      // init tooltips
      const tooltipOptions = {
        placement: 'top',
        html: true
      }

      tooltips.forEach(el => window.createTooltips(el, tooltipOptions))
    }, 1000)
  }
}

export default LoadTransactionsController
